// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["DisplayOnlyMember"]);
}

function unwrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["TeamAccountProfile"]);
}

function unwrap_response_updateUnifiedDisplayMemberSocialAccounts(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "UnifiedProfileConversionCommitted",
    "UnifiedProfileConversionOutcomeUnknown",
    "UnifiedProfileNotUnifiedError",
    "UnifiedProfileUpdateFailed",
    "UpdateUnifiedAccountProfilePayload"
  ]);
}

let variablesConverter = {"unifiedProfileSocialInput":{},"unifiedProfileMemberSocialsInput":{"social":{"r":"unifiedProfileSocialInput"}},"__root":{"input":{"r":"unifiedProfileMemberSocialsInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node_DisplayOnlyMember":{"f":""},"updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node":{"u":"response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node"},"updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile":{"f":""},"updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile":{"u":"response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile"},"updateUnifiedDisplayMemberSocialAccounts":{"u":"response_updateUnifiedDisplayMemberSocialAccounts"}}};

let wrapResponseConverterMap = {
  response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node: RescriptRelay_Internal.wrapUnion,
  response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile: RescriptRelay_Internal.wrapUnion,
  response_updateUnifiedDisplayMemberSocialAccounts: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node_DisplayOnlyMember":{"f":""},"updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node":{"u":"response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node"},"updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile":{"f":""},"updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile":{"u":"response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile"},"updateUnifiedDisplayMemberSocialAccounts":{"u":"response_updateUnifiedDisplayMemberSocialAccounts"}}};

let responseConverterMap = {
  response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node: unwrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node,
  response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile: unwrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile,
  response_updateUnifiedDisplayMemberSocialAccounts: unwrap_response_updateUnifiedDisplayMemberSocialAccounts
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "UnifiedProfileNotUnifiedError",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "UnifiedProfileConversionCommitted",
  "abstractKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "UnifiedProfileConversionOutcomeUnknown",
  "abstractKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "UnifiedProfileUpdateFailed",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v12 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "width",
        "value": 48
      }
    ],
    "kind": "ScalarField",
    "name": "url",
    "storageKey": "url(width:48)"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedDisplayOnlyMemberSocialAccountsFormMemberSocialsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUnifiedDisplayMemberSocialAccounts",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "UnifiedProfileSave_updatedMembers"
                      },
                      {
                        "alias": null,
                        "args": (v3/*: any*/),
                        "concreteType": "TeamAccountProfileMemberConnection",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamAccountProfileMemberEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "UnifiedDisplayOnlyMemberSocialAccountsForm_displayOnlyMember"
                                      }
                                    ],
                                    "type": "DisplayOnlyMember",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "members(first:100)"
                      }
                    ],
                    "type": "TeamAccountProfile",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UpdateUnifiedAccountProfilePayload",
            "abstractKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnifiedDisplayOnlyMemberSocialAccountsFormMemberSocialsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUnifiedDisplayMemberSocialAccounts",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v3/*: any*/),
                        "concreteType": "TeamAccountProfileMemberConnection",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamAccountProfileMemberEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "firstName",
                                        "storageKey": null
                                      },
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MarketingProfileSocialAccounts",
                                        "kind": "LinkedField",
                                        "name": "socialAccounts",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "twitter",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "facebook",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "instagram",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "linkedIn",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "youTube",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "tikTok",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "yelp",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "DisplayOnlyMember",
                                    "abstractKey": null
                                  },
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "members(first:100)"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": (v3/*: any*/),
                                "concreteType": "TeamAccountProfileMemberConnection",
                                "kind": "LinkedField",
                                "name": "members",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamAccountProfileMemberEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v9/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Agent",
                                                "kind": "LinkedField",
                                                "name": "agent",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "id",
                                                    "storageKey": null
                                                  },
                                                  (v10/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ProfilePhoto",
                                                    "kind": "LinkedField",
                                                    "name": "profilePhoto",
                                                    "plural": false,
                                                    "selections": (v12/*: any*/),
                                                    "storageKey": null
                                                  },
                                                  (v9/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "role",
                                                "storageKey": null
                                              },
                                              (v13/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "visibility",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "UserBoundMember",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v13/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ProfilePhoto",
                                                "kind": "LinkedField",
                                                "name": "profilePicture",
                                                "plural": false,
                                                "selections": (v12/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "DisplayOnlyMember",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "members(first:100)"
                              }
                            ],
                            "type": "TeamAccountProfile",
                            "abstractKey": null
                          }
                        ],
                        "type": "AccountProfile",
                        "abstractKey": "__isAccountProfile"
                      }
                    ],
                    "type": "TeamAccountProfile",
                    "abstractKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "UpdateUnifiedAccountProfilePayload",
            "abstractKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c3504de5a457461b968c7a373f438ade",
    "id": null,
    "metadata": {},
    "name": "UnifiedDisplayOnlyMemberSocialAccountsFormMemberSocialsMutation",
    "operationKind": "mutation",
    "text": "mutation UnifiedDisplayOnlyMemberSocialAccountsFormMemberSocialsMutation(\n  $input: UnifiedProfileMemberSocialsInput!\n) {\n  updateUnifiedDisplayMemberSocialAccounts(input: $input) {\n    __typename\n    ... on UpdateUnifiedAccountProfilePayload {\n      profile {\n        __typename\n        ... on TeamAccountProfile {\n          ...UnifiedProfileSave_updatedMembers\n          members(first: 100) {\n            edges {\n              node {\n                __typename\n                ... on DisplayOnlyMember {\n                  ...UnifiedDisplayOnlyMemberSocialAccountsForm_displayOnlyMember\n                }\n                ... on Node {\n                  __isNode: __typename\n                  __typename\n                  nodeId\n                }\n              }\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n    ... on UnifiedProfileNotUnifiedError {\n      message\n    }\n    ... on UnifiedProfileConversionCommitted {\n      message\n    }\n    ... on UnifiedProfileConversionOutcomeUnknown {\n      message\n    }\n    ... on UnifiedProfileUpdateFailed {\n      message\n    }\n  }\n}\n\nfragment UnifiedDisplayOnlyMemberSocialAccountsForm_displayOnlyMember on DisplayOnlyMember {\n  nodeId\n  firstName\n  displayName\n  socialAccounts {\n    twitter\n    facebook\n    instagram\n    linkedIn\n    youTube\n    tikTok\n    yelp\n  }\n}\n\nfragment UnifiedProfileSave_updatedMembers on AccountProfile {\n  __isAccountProfile: __typename\n  __typename\n  ... on TeamAccountProfile {\n    nodeId\n    members(first: 100) {\n      edges {\n        node {\n          __typename\n          ... on UserBoundMember {\n            nodeId\n            ...UnifiedTeamAccountProfileMemberRow_userMember\n          }\n          ... on DisplayOnlyMember {\n            nodeId\n            ...UnifiedTeamAccountProfileMemberRow_displayOnlyMember\n          }\n          ... on Node {\n            __isNode: __typename\n            __typename\n            nodeId\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment UnifiedTeamAccountProfileMemberRow_displayOnlyMember on DisplayOnlyMember {\n  nodeId\n  displayName\n  title\n  profilePicture {\n    url(width: 48)\n  }\n}\n\nfragment UnifiedTeamAccountProfileMemberRow_userMember on UserBoundMember {\n  nodeId\n  agent {\n    id\n    displayName\n    profilePhoto {\n      url(width: 48)\n    }\n    nodeId\n  }\n  role\n  title\n  visibility\n}\n"
  }
};
})());

let wrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node = RescriptRelay_Internal.wrapUnion;

let wrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile = RescriptRelay_Internal.wrapUnion;

let wrap_response_updateUnifiedDisplayMemberSocialAccounts = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node = unwrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node;
exports.wrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node = wrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile_TeamAccountProfile_members_edges_node;
exports.unwrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile = unwrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile;
exports.wrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile = wrap_response_updateUnifiedDisplayMemberSocialAccounts_UpdateUnifiedAccountProfilePayload_profile;
exports.unwrap_response_updateUnifiedDisplayMemberSocialAccounts = unwrap_response_updateUnifiedDisplayMemberSocialAccounts;
exports.wrap_response_updateUnifiedDisplayMemberSocialAccounts = wrap_response_updateUnifiedDisplayMemberSocialAccounts;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
